export class TabIdGenerator {
	static generateInstanceTabId(instanceId: string, searchTerm?: string): string {
		const cleanSearchTerm = searchTerm?.trim() || '';
		const baseId = `instance-${instanceId}`;

		if (!cleanSearchTerm) {
			return baseId;
		}

		const searchHash = this.hashSearchTerm(cleanSearchTerm);
		return `${baseId}-${searchHash}`;
	}

	static generateSharedQueryTabId(instanceId: string, queryValue: string, searchTerm?: string): string {
		const cleanQueryValue = queryValue.trim();
		const queryHash = this.hashSearchTerm(cleanQueryValue);
		const cleanSearchTerm = searchTerm?.trim() || '';

		const baseId = `sharedquery-${instanceId}-${queryHash}`;

		if (!cleanSearchTerm) {
			return baseId;
		}

		const searchHash = this.hashSearchTerm(cleanSearchTerm);
		return `${baseId}-${searchHash}`;
	}

	private static hashSearchTerm(str: string): string {
		let hash = 0;
		for (let i = 0; i < str.length; i++) {
			const char = str.charCodeAt(i);
			hash = (hash << 5) - hash + char;
			hash = hash & hash;
		}
		return Math.abs(hash).toString(36);
	}
}
